import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import CustomMock from '../interfaces/CustomMock';
import DocumentFile from '../interfaces/DocumentFile';
import { MyPromise } from '../interceptors/myPromise.service';

const BASEURL = `${environment.baseEndpointPHP}`;
const BASE_URL_NODE =  `${environment.baseEndpoint}`;

@Injectable({
  providedIn: 'root',
})
export class ProceduresService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  storeDocument(data: DocumentFile) {
    return this.myPromise.to(this.http.post(`${BASEURL}/document`, data));
  }

  deleteFileByUrl(url: string) {
    return this.myPromise.to(this.http.post(`${BASE_URL_NODE}/filesv2/delete/file/url`, { url }));
  }

  deleteDocument(id: number) {
    return this.myPromise.to(this.http.delete(`${BASEURL}/document/${id}`));
  }

  getDataDocumentBridge(station_id: string) {
    return this.myPromise.to(this.http.get(`${BASEURL}/mock/data/station/${station_id}/document-bridge`));
  }

  getMocksForName(station_id: string, name: string) {
    return this.myPromise.to(this.http.get(`${BASEURL}/mock/data/station/${station_id}/type`, { params: {name} }));
  }

  getMocksForNameAndSection(station_id: string, name: string, section: string) {
    return this.myPromise.to(this.http.get(`${BASEURL}/mock/data/station/${station_id}/type/section`, { params: { name, section } }));
  }

  editOrStoreItemMock(data: CustomMock) {
    return this.myPromise.to(this.http.post(`${BASEURL}/mock/custom/data`, data));
  }

  storeWithoutMockParent(data: CustomMock) {
    return this.myPromise.to(this.http.post(`${BASEURL}/without-mock/custom/data`, data));
  }
}
